import React from 'react';
import PropTypes from 'prop-types';

const Triplex = ({ className, checked }) => (
    <svg
        width="56px"
        height="56px"
        viewBox="0 0 56 56"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className} ${checked ? 'path__fill__checked' : 'path__fill'}`}
    >
        <title>Triplex</title>
        <desc>Created with Sketch.</desc>
        <g
            id="assets"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
            fillOpacity="0.6"
        >
            <g id="Triplex" fill="#393939">
                <path
                    d="M33,48 L33,38 L33,21 C33,18.243 30.757,16 28,16 C25.243,16 23,18.243 23,21 L23,38 L23,48 L17,48 L17,13.618 L28,8.118 L39,13.618 L39,48 L33,48 Z M25,48 L31,48 L31,39 L25,39 L25,48 Z M31,27 L25,27 L25,21 C25,19.346 26.346,18 28,18 C29.654,18 31,19.346 31,21 L31,27 Z M25,37 L31,37 L31,29 L25,29 L25,37 Z M45,48 L41,48 L41,13 C41,12.621 40.786,12.275 40.447,12.105 L28.447,6.105 C28.166,5.965 27.834,5.965 27.553,6.105 L15.553,12.105 C15.214,12.275 15,12.621 15,13 L15,48 L11,48 C10.448,48 10,48.447 10,49 C10,49.553 10.448,50 11,50 L16,50 L24,50 L32,50 L40,50 L45,50 C45.553,50 46,49.553 46,49 C46,48.447 45.553,48 45,48 L45,48 Z"
                    id="Page-1"
                />
            </g>
        </g>
    </svg>
);

Triplex.displayName = 'Triplex';

Triplex.propTypes = {
    checked: PropTypes.bool,
    className: PropTypes.string,
};

/**
 * Triplex Functional Component.
 */
export default Triplex;
